declare const __SENTRY_RELEASE_FALLBACK__: string | undefined;

export function resolveRelease(explicitRelease?: string): string | undefined {
  return (
    explicitRelease?.trim() ||
    import.meta.env.VITE_SENTRY_RELEASE?.trim() ||
    __SENTRY_RELEASE_FALLBACK__ ||
    undefined
  );
}
